<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button icon="el-icon-download" @click="onExport"
          >导出</el-button
        ></template
      >
    </list>
  </div>
</template>
  <script>
import curdMixins from "@/mixins/curd";
import list from "@/components/wh/attrinventory/list";

export default {
  name: "attrinventory",
  mixins: [curdMixins],
  components: {
    list,
  },
  methods: {
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
  },
};
</script>